<template>
  <div id="app">

    <transition name="slide-fade-y-up">
        <Navbar
          :userinfo="userInfoArr"
          v-show="this.$store.state.showNavbar"
        />
    </transition>

    <transition name="slide-fade-y">
        <BottomNav
          :userinfo="userInfoArr"
          v-show="!this.$store.state.showNavbar"
        />
    </transition>

    <transition name="slide-fade-x-left">
        <Menu 
          v-show="toggleMenu"
          :userinfo="userInfoArr"
        />
    </transition>

    <transition name="slide-fade-x-right">
        <Login 
          v-show="toggleLogin"
          :userinfo="userInfoArr"
        />
    </transition>

    <transition name="slide-fade-x-right">
        <CreatePost 
          v-show="toggleCreatePost"
          :userinfo="userInfoArr"
        />
    </transition>

    <transition name="slide-fade-y">
        <PopMess 
          v-show="togglePopMess"
          :popMessText="this.$store.state.popMessText"
        />
    </transition>

    <Legal
      v-show="toggleLegal"
    />
    <About
      v-show="toggleAbout"
    />
    <Contact
      v-show="toggleContact"
    />

    <router-view
      :userinfo="userInfoArr" 
      :useractions="userActionsArr"
    />

  </div>
</template>
<script>
import { auth, db, fs, analytic, performance } from './db'

import Navbar from '@/components/Navbar.vue'
import CreatePost from '@/components/CreatePost.vue'
import Login from '@/components/Login.vue'
import PopMess from '@/components/PopMess.vue'
import Menu from '@/components/Menu.vue'
import Legal from '@/components/Legal.vue'
import About from '@/components/About.vue'
import Contact from '@/components/Contact.vue'
import BottomNav from '@/components/BottomNav.vue'

export default {
  name: 'app',
  components: {
    Navbar,
    Login,
    CreatePost,
    PopMess,
    Menu,
    Legal,
    About,
    Contact,
    BottomNav
  },
  fiery: true, // required to add this.$fiery to this component
  data() {
    const $fiery = this.$fiery
    return {
      userInfoArr: null,
      userActionsArr: null,
    }
  },
  created () {
    this.userActions
    this.onScroll()
  },
  computed: {
      userActions() { 
        auth.onAuthStateChanged(user => {
            if (user) {
              console.log(`Logged in user: ${user.uid}`)
              this.userInfoArr = this.$fiery(db.collection('users').doc(user.uid), {
                key: 'id', 
                propExists: 'exists', 
                exclude: ['id', 'exists'] 
                })
              // this.userActionsArr = this.$fiery(db.collection('users').doc(user.uid).collection('actions'))
this.userActionsArr = this.$fiery(db.collection('users').doc(user.uid))
//?????????? Får den här realtid reads "uppdateringar" ifrån alla users i collection users?

            } else {
                // reject(Error('Something broken with auth'));
                console.log('Not logged in')
            }
        })
      },
      toggleCreatePost(){
        return this.$store.state.showCreatePost
      },
      toggleLogin(){
        return this.$store.state.showLogin
      },
      togglePopMess(){
        return this.$store.state.showPopMess
      },
      toggleMenu(){
        return this.$store.state.showMenu
      },
      toggleLegal(){
        return this.$store.state.showLegal
      },
      toggleAbout(){
        return this.$store.state.showAbout
      },
      toggleContact(){
        return this.$store.state.showContact
      },
      toggleCreatePost(){
        return this.$store.state.showCreatePost
      },
      onScroll() {
        this.$store.dispatch('onScroll')
      },

  },
}
</script>

<style lang="scss">
body {
  margin: 0;
  padding: 0;
  background-color: $primary-bg-color;
  font-family: $family;
  h1 {
    font-family: $family-medium;
    font-size: $h1;
    font-weight: normal;
    font-style: normal;
    color: $black;
  }
  a {
    text-decoration: none;
    color: inherit;
  }
  p {
    // font-weight: $bold;
    font-size: $p1;
    color: $p-color;
  }
  p.minor {
      // font-weight: $medium;
      font-size: $p2;
  }
  small {
    font-size: $p2;
  }

  .col2 {
    width: $col2;
    margin-right: $main-margin;
  }
  .col3 {
    width: $col3;
    margin-right: $main-margin;
  }

  .d-f {
    display: flex;
  }

  .button {
    border: 0;
    cursor: pointer;
    background-color: $button-color;
    border: 2px solid $black;
    font-size: $p1;
    font-family: $family;
    height: $button-height;
    min-width: $button-min-w;
    display: flex;
    align-items: center;
    justify-content: center;
    span {
      padding: 0 10px;
      line-height: 1;
    }
    @media #{$no-mob-hover} {
      &:hover {
        background-color: $button-hover-color;
        color: $primary-bg-color;
      }
    }
  }
  .button-2 {
    border: 0;
    cursor: pointer;
    font-size: $p1;
    font-family: $family;
    display: flex;
    align-items: center;
    justify-content: center;
    color: $black;
    padding: 10px 20px;
    background-color: $grey;
    span {
      // padding: 0 1px;
      line-height: 1;
    }
    @media #{$no-mob-hover} {
      &:hover {
        background-color: $button-hover-color;
        color: $primary-bg-color;
      }
    }
  }
  .disabled-button {
    background-color: $grey;
    border: none;
    color: $black;
    opacity: .3;
  }
  .underline-button {
    position: relative;
    @media #{$no-mob-hover} {    
      &:hover {
        cursor: pointer;
        color: $icon-hover-color;
      }
    }
    &:before {
      border-bottom: 0.125em solid $icon-hover-color;
      content: "";
      left: 0;
      margin-bottom: calc(0.125em / 2 * -1);
      position: absolute;
      right: 0;
      bottom: 0;
    }
    @media #{$no-mob-hover} {    
        &:hover::before {
        border-bottom: 0.125em solid $icon-hover-color;
        content: "";
        left: 0;
        margin-bottom: calc(0.125em / 2 * -1);
        position: absolute;
        right: 0;
        bottom: 50%;
        }
    }
  }
  .strike {
    position: relative;
    color: $icon-hover-color;
    @media #{$no-mob-hover} {
      &:hover {
        color: $black;
      }
    }
    &:before {
      border: 0;
    }
    &:after {
      border-bottom: 0.125em solid $icon-hover-color;
      content: "";
      left: 0;
      margin-top: calc(0.125em / 2 * -1);
      position: absolute;
      right: 0;
      top: 50%;
    }
  }
  .striketext {
    text-decoration: line-through;
    color: $icon-hover-color !important;
  }
  .dotbefore {
    &:before {
      content: '● ';
    }
  }
  .active-color {
    color: $icon-hover-color;
  }
  .dark-grey {
    color: $p-color;
  }
  .button-strike {
    // text-decoration: line-through;
    // line-height: 1rem;
    position: relative;
  }
  .button-text {
    cursor: pointer;
    color: $icon-color;
    @media #{$no-mob-hover} {
      &:hover {
        color: $icon-hover-color;
      }
    }
  }
  .button-text-grey {
    cursor: pointer;
    color: $p-color;
    @media #{$no-mob-hover} {
      &:hover {
        color: $icon-hover-color;
      }
    }
  }
  .button-text-white {
    cursor: pointer;
    color: $white;
    @media #{$no-mob-hover} {
      &:hover {
        color: $icon-hover-color;
      }
    }
  }

  @media #{$no-mob-hover} {
    .hover-margin-lt {
      &:hover {
        padding-left: 5px !important;
        transition: padding 50ms ease-in-out;
      }
    }
    .hover-margin-lt-big {
      &:hover {
        padding-left: 15px !important;
        transition: padding 50ms ease-in-out;
      }
    }
    .close {
      &:hover {
        transform: rotate(90deg);
        transition: 200ms ease all;
      }
    }
  }

  .uppercase {
    text-transform: uppercase;
  }
  .icon-margin {
    margin: $icon-margin;
  }
  .icon-margin-lt {
    margin-left: $icon-margin;
  }
  .icon-margin-rt {
    margin-right: $icon-margin;
  }
  .form .minor {
    margin-bottom: 0;
    padding-top: calc(#{$main-margin} * 2);
  }
  input, textarea {
    background-color: transparent;
    padding: 0;
    font-family: $family;
    font-size: $p1;
    line-height: calc(#{$main-margin} * 2);
    // border: $line-bold solid $line-color-dark;
    // border: $line-thin solid $line-color-light;
    // border: none;
    // background-color: $button-color;
    border-left: none; border-right: none; border-top: none;
    border-bottom: $line-bold solid $line-color-dark;
    border-radius: 0;
    width: 100%;
  }
  input:focus, textarea:focus, button:focus {
      outline: none;
  }
  input:-webkit-autofill {
    -webkit-box-shadow: 0 0 0px 1000px #fff inset;
    box-shadow: 0 0 0px 1000px #fff inset;
  }
  .icon-search, .icon-menu, .icon-cancel {
    cursor: pointer;
    fill: $icon-color;
    padding: 0 20px;
    @media #{$no-mob-hover} {
      &:hover {
        fill: $icon-hover-color;
      }
    }
  }
  .icon-logo {
    height: 22px;
  }
  .btn-load-more {
    width: 100%;
    height: $monster-btn;
    background-color: $grey;
    color: $black;
    display: flex;
    align-items: center;
    // justify-content: space-between;
    padding: $grid-padding;
    box-sizing: border-box;
    margin: 0;
    h1 {
      &:nth-child(1) {
        width: $col2;
        margin-right: $main-margin;
      }
      &:nth-child(2) {
        margin-right: auto;
        text-decoration: underline;
      }
    }
    @media #{$no-mob-hover} {
      &:hover {
        cursor: pointer;
        background-color: $icon-hover-color;
        h1 {
          color: $black;
          span {
            color: $black;
            text-decoration: none;
          }
        }
      }
    }
    @media #{$mobile} { 
      margin: 0;
      padding: $main-margin-mobile;
      height: $monster-btn-mobile;
    }
  }
  .scroll-off {
    height: 100vh;
    overflow: hidden;
  }

}

// MOBILE
@media #{$mobile} { 
  body {
    h1 {
      font-size: $h1-mobile;
    }
    .icon-search, .icon-menu, .icon-cancel, .icon-logo {
      padding: 0 $main-margin-mobile;
    }
    .icon-logo {
      height: 20px;
    }
  }
}

</style>
